<template>
  <ontick-modal :open="active" size="medium" v-on:close="$emit('close')">
    <div class="py-6">
      <div class="h-96 max-w-6xl overflow-y-auto text-gray-300">
        <h1 class="mb-2 text-3xl font-bold">Termos de Uso</h1>
        <p class="mb-2 font-semibold">
          Prezado Usuário, seja bem-vindo à plataforma OnTick Invest!
        </p>
        <p class="mb-2">
          Por favor, leia atentamente estes Termos de Uso antes de acessar a
          Plataforma ou utilizar nossos serviços. Caso tenha qualquer dúvida,
          estamos à disposição para ouvi-lo, entre em contato conosco através do
          e-mail contato@ontick.com.br. Sua opinião é muito importante para a
          OnTick Invest.
        </p>
        <p class="mb-2">
          Ao acessar ou utilizar a Plataforma, o Usuário concorda com estes
          Termos de Uso (“Termo” ou “Termos”). Caso o Usuário não concorde com o
          teor de qualquer uma das disposições deste documento, solicitamos que
          não utilize a Plataforma e/ou os serviços oferecidos.
        </p>
        <p class="mb-6">
          É muito importante a leitura atenta destes Termos de Uso no ato de seu
          cadastro na OnTick Invest, pois ao se cadastrar, você estará aceitando
          as nossas regras, as quais regerão o nosso relacionamento. A adesão à
          plataforma OnTick Invest e seus serviços, benefícios e funcionalidades
          são oferecidos a exclusivo critério da OnTick Invest (OnTick Invest
          Serviços Financeiros LTDA.), que se reserva o direito de alterar as
          regras a qualquer momento, no todo ou em parte, mediante aviso aos
          Usuários, na forma descrita nos Termos de Uso.
        </p>

        <h3 class="mb-2 text-xl font-bold">1. Introdução</h3>
        <p class="mb-2">
          Agradecemos pelo interesse na plataforma virtual desenvolvida e
          mantida pela OnTick Invest Serviços Financeiros LTDA. (“OnTick
          Invest”), pessoa jurídica de direito privado, inscrita no CNPJ sob o
          no 42.386.116/0001-50, sediada na Rua Manoel Feu Subtil, 60, Sala
          202C, Enseada do Suá, Vitória-ES, CEP: 29050-400.
        </p>
        <p class="mb-2">
          A OnTick Invest desenvolveu e explora a plataforma inserida em seu
          domínio web – ontick.com.br – (“Site”), os quais são essenciais para a
          realização da prestação dos serviços a que se dispõe.
        </p>
        <p class="mb-2">
          O presente Termos de Uso (“Termo” ou “Termos”) estabelece a relação
          contratual entre os clientes que utilizam a Plataforma (“Usuários”),
          estabelecendo as regras de utilização e as responsabilidades de cada
          parte, em conformidade com a legislação brasileira, incluindo as
          disposições da Lei no 12.965/14 (“Marco Civil da Internet”).
        </p>
        <p class="mb-2">
          Antes de prosseguir, é fundamental que você leia e compreenda todos os
          Termos que regulam a utilização da Plataforma e de seus benefícios.
          Por isso, criamos este contrato virtual, que foi inclusive redigido de
          forma clara e em linguagem acessível.
        </p>
        <b class="mb-2"
          >Ao marcar a opção “Aceitar termos de uso”, você estará legalmente
          vinculado a todos os termos e condições aqui presentes. Caso você não
          concorde com qualquer das regras previstas, você deverá não aceitar
          esse Termo e não deverá utilizar a Plataforma OnTick Invest.</b
        >
        <p class="mb-6">
          Caso tenha qualquer dúvida sobre o conteúdo desses Termos de Uso,
          entre em contato com nosso suporte através do e-mail:
          contato@ontick.com.br. Será um prazer atendê-lo!
        </p>

        <h3 class="mb-2 text-xl font-bold">
          2. A Plataforma e as estratégias de investimentos
        </h3>
        <p class="mb-2">
          2.1. <a href="" class="italic underline">A OnTick Invest.</a> A OnTick
          Invest é uma plataforma totalmente baseada em nuvem, que tem como
          missão fornecer para os investidores brasileiros uma grande variedade
          de estratégias e produtos financeiros, fazendo uso de tecnologias
          modernas e visando facilitar o acesso a soluções automatizadas de
          investimento.
        </p>
        <p class="mb-2">
          2.2. <a href="" class="italic underline">A Plataforma.</a> A OnTick
          Invest desenvolveu e explora uma plataforma online para investimentos
          automatizados, que envia ordens de compra e venda de valores
          mobiliários diretamente para as principais corretoras de valores
          mobiliários atuantes na B3, através de produtos e soluções
          automatizadas escolhidas e parametrizadas pelos próprios Usuários,
          sendo tais produtos elaborados e comercializados pela OnTick Invest ou
          por terceiros.
        </p>
        <p class="mb-2 font-bold">
          2.3. A Plataforma não é em si um robô de investimentos, mas sim um
          ambiente online que permite que as estratégias disponíveis na
          plataforma possam transmitir ordens de compra e venda diretamente para
          corretoras de valores mobiliários parceiras, seguindo parâmetros
          configurados pelo próprio Usuário.
        </p>
        <p class="mb-2">
          2.4. <a href="" class="italic underline"> As estratégias.</a> Na
          Plataforma, portanto, podem ser executadas estratégias de
          investimentos criadas: (i) pelos Usuários, mediante a configuração na
          Plataforma de ordens de compra e venda de ativos conforme os
          parâmetros que desejarem; (ii) pela OnTick Invest ou por seus
          Parceiros, de acordo com parâmetros definidos por especialistas do
          mercado financeiro; e (iii) por terceiros, que não possuem relação com
          a OnTick Invest, mas desenvolvem de forma independente estratégias
          compatíveis com a Plataforma.
        </p>
        <p class="mb-2">
          2.5.
          <a href="" class="italic underline">
            Estratégias Criadas pelos Usuários.</a
          >
          Por meio de contratação de produtos específicos, o Usuário terá acesso
          às funcionalidades desse produto, que lhe permitirão configurar suas
          próprias estratégias de investimentos, de acordo com a lógica
          desenvolvida e parâmetros oferecidos pelo algoritmo de investimento.
        </p>
        <p class="mb-2">
          2.6.
          <a href="" class="italic underline">
            Estratégias da OnTick Invest ou de Parceiros.</a
          >
          Além da criação de estratégias próprias, o Usuário poderá contratar
          outras elaboradas pela OnTick Invest ou por seus Parceiros, cujas
          parametrizações já vêm especificadas por analistas CNPI-T
          (certificados pela APIMEC). As estratégias de parceiros estarão
          sujeitas a cobranças além da assinatura da plataforma.
        </p>
        <p class="mb-2">
          2.7.
          <a href="" class="italic underline"> Estratégias de Terceiros.</a>
          Existem terceiros que, sem qualquer relação comercial ou jurídica com
          a OnTick Invest, fornecem estratégias de investimentos compatíveis com
          a nossa Plataforma.
          <b>
            Essas estratégias são elaboradas sem a participação da OnTick
            Invest, e não possuímos qualquer controle ou ingerência sobre o
            conteúdo e sobre a procedência das mesmas. Se o Usuário desejar usar
            nossa Plataforma para executar essas estratégias de terceiros, deve
            estar ciente de que a OnTick Invest não possui qualquer
            responsabilidade sobre elas. Recomendamos fortemente que o Usuário
            verifique a seriedade e legalidade da atividade desses terceiros,
            antes de efetuar qualquer contratação.</b
          >
        </p>
        <p class="mb-2">
          2.8.
          <a href="" class="italic underline"> Riscos e Perdas.</a> Cabe aqui
          destacar que
          <b
            >investir em valores mobiliários é uma atividade arriscada, dado a
            elevada volatilidade e grande possibilidade de perdas,</b
          >
          especialmente no curto e médio prazos. É, portanto, destinada a perfis
          arrojados de investidores, que estão dispostos a assumirem elevado
          risco. Se a atuação com valores mobiliários é, por si só, uma
          atividade arriscada,
          <b
            >utilizar algoritmos de investimentos para o envio automatizado de
            ordens de compra e venda é uma atividade de altíssimo risco, sujeita
            a perdas consideráveis,</b
          >
          e, por essa razão, deve ser destinada apenas a investidores
          experientes e com grande propensão ao risco. Dessa forma,
          <b
            >a execução de estratégias de investimentos através da nossa
            Plataforma é voltada para Usuários experientes e arrojados, que
            estão cientes dos riscos e das possibilidades de perdas envolvidas
            neste tipo de atividade, inclusive decorrentes do próprio uso da
            tecnologia.</b
          >
        </p>
        <p class="mb-2">
          2.9.
          <a href="" class="italic underline"> O Ambiente de Simulação.</a>
          Mesmo sendo voltada para Usuários experientes e arrojados,
          <b
            >a Plataforma possui um ambiente de simulação, no qual as
            estratégias não operam no mercado real:</b
          >
          ou seja, não há efetivamente envio das ordens para as corretoras, e,
          portanto, não há compra e venda de valores mobiliários e os ganhos ou
          perdas apresentados nesse ambiente são fictícios.
          <b
            >A OnTick Invest recomenda fortemente que os Usuários tenham o
            costume de operar cada nova estratégia desenvolvida ou contratada no
            ambiente simulado, por um tempo relevante e suficiente para avaliar
            a forma de funcionamento e os riscos inerentes ao algoritmo em
            questão e à sua estratégia de investimento, antes de os submeter ao
            mercado real.</b
          >
          Dessa forma, os Usuários podem visualizar e avaliar melhor as
          estratégias de investimentos escolhidas, eventualmente, realizar algum
          ajuste nas parametrizações. Não obstante, reforça-se que o Ambiente de
          Simulação pode apresentar resultados diferentes com relação ao mercado
          real, tendo em vista que a simulação perfeita é tecnicamente
          impossível – isto é, o Ambiente Simulado serve para que o Usuário
          tenha uma boa noção do funcionamento das estratégias, mas não
          refletirá exata e precisamente a sua atuação no mercado real.
        </p>
        <p class="mb-2">
          2.10.
          <a href="" class="italic underline">
            As Corretoras de Valores Mobiliários.</a
          >
          Para operar efetivamente no mercado real, e não no Ambiente Simulado,
          o Usuário deverá possuir uma conta ativa e regular em uma das
          corretoras de valores mobiliários integradas à Plataforma (listadas no
          Site da OnTick Invest). O Usuário poderá optar por qualquer das
          corretoras integradas à Plataforma, sendo que a OnTick Invest não
          confere nenhuma preferência ou tratamento diferenciado aos Usuários em
          função da corretora escolhida. Caso o Usuário já tenha conta em outra
          corretora, ainda não integrada à Plataforma, poderá entrar em contato
          pelo e-mail contato@ontick.com.br para que a OnTick Invest verifique a
          possibilidade de integração, o que ocorrerá apenas na medida do
          possível. Desnecessário lembrar que a relação entre o Usuário e sua
          corretora é totalmente distinta e autônoma da relação entre o Usuário
          e a OnTick Invest: não temos qualquer responsabilidade ou ingerência
          nesta relação.
        </p>
        <p class="mb-6">
          2.11. A forma e as funcionalidades da Plataforma poderão mudar
          ocasionalmente sem aviso prévio, já que a OnTick Invest busca
          constantemente inovação tecnológica para o cumprimento dos seus
          propósitos. Da mesma forma, o modelo de exploração de cada
          funcionalidade da Plataforma pode ser alterado.
        </p>

        <h3 class="mb-2 text-xl font-bold">3. Cadastro</h3>
        <p class="mb-2">
          3.1. Primeiramente, o Usuário deve fazer um cadastro em nosso Site,
          fornecendo algumas informações. A OnTick Invest é obrigada a agir em
          conformidade com a legislação vigente, em especial a Lei nº 12.965/
          2014 (Marco Civil da Internet), e Lei nº 13.709/2018 (Lei Geral de
          Proteção de Dados Pessoais) e seus decretos, na coleta, armazenamento,
          compartilhamento, transmissão, disponibilização e tratamento de dados
          pessoais do Usuário.
        </p>
        <p class="mb-2">
          3.2. As informações prestadas no cadastro devem ser exatas, precisas e
          verdadeiras, e o Usuário se compromete a atualizar o cadastro sempre
          que houver alguma alteração nos seus dados.
        </p>
        <p class="mb-2">
          3.3. Após a conclusão do cadastro, o Usuário terá
          <b>um login,uma senha e uma assinatura eletrônica.</b> Este login,
          esta senha e esta assinatura eletrônica são de uso pessoal e
          intransferível, e de uso exclusivo, não podendo ser repassados a
          terceiros. O Usuário assume, portanto,
          <b>total responsabilidade por sua guarda e sigilo,</b> com a obrigação
          de evitar que sejam utilizados por terceiros. A assinatura eletrônica
          será exigida pela plataforma em todas as ações que envolvam a
          inicialização, parametrização e finalização das estratégias
          investimentos.
        </p>
        <p class="mb-2">
          3.4. O Usuário deverá mudar sua senha periodicamente, no máximo a cada
          180 (cento e oitenta) dias. Recomendamos fortemente que não utilize
          senhas que facilitem a adivinhação por terceiros, como números de
          telefone, endereço, datas de nascimento, nomes de parentes, etc.
        </p>
        <p class="mb-2">
          3.5. Caso o Usuário tome conhecimento ou suspeite de qualquer
          utilização não autorizada no seu login, senha ou assinatura
          eletrônica, deverá imediatamente alterar sua senha e informar a OnTick
          Invest.
        </p>
        <p class="mb-6">
          3.6. Cada Usuário somente poderá criar e manter um único cadastro, sob
          pena de desativação de todos os cadastros referentes ao mesmo Usuário
          sem qualquer aviso prévio.
        </p>

        <h3 class="mb-2 text-xl font-bold">4. Contratação de Produtos</h3>
        <p class="mb-2">
          4.1. A OnTick Invest poderá, sob seu exclusivo critério,
          discricionariedade e conveniência, alterar, incluir ou remover
          produtos oferecidos, assim como suas periodicidades, preço e formas de
          pagamento.
        </p>
        <p class="mb-2">
          4.2. Uma vez realizada a contração de um produto, a não utilização do
          mesmo não isenta o Usuário do pagamento do plano contratado.
        </p>
        <p class="mb-2">
          4.3. Os planos dos produtos, com exceção do gratuito, ficam liberados
          para utilização após a confirmação do pagamento respectivo.
        </p>
        <p class="mb-2">
          4.4. Ao final do período contratado, caso não haja manifestação em
          contrário por parte do Usuário, a renovação do plano do produto se
          dará de forma automática, conforme os preços e condições vigentes na
          época da renovação, incluindo eventuais reajustes.
        </p>
        <p class="mb-2">
          4.4.1. O prazo contratado vencerá no mesmo dia da data da assinatura
          do mês subsequente caso a periodicidade seja mensal, três meses após a
          assinatura caso o plano seja trimestral, seis meses após a assinatura
          caso seja semestral e no mesmo dia do ano seguinte caso se trate de
          assinatura anual, seguindo o mesmo padrão em casos de planos com
          periodicidades diversas das anteriores.
        </p>
        <p class="mb-6">
          4.5. Em caso de inadimplência, transcorrido o prazo da cláusula 4.4 o
          Usuário será automaticamente transferido para o plano gratuito, caso
          haja. Na eventualidade de não haver um plano gratuito para o produto
          contratado o plano será desabilitado automaticamente.
        </p>

        <h3 class="mb-2 text-xl font-bold">
          5. Obrigações e Responsabilidades
        </h3>
        <p class="mb-2">
          5.1. Conforme o item 2.8, a Plataforma é destinada a Usuários
          experientes, arrojados, com propensão ao risco e com elevado
          conhecimento do mercado de valores mobiliários. Dessa forma, cada
          Usuário é responsável pelas decisões tomadas no âmbito da Plataforma.
          Não somos e nem poderíamos ser responsáveis por qualquer ação ou
          omissão dos Usuários tomada com base em informações, anúncios ou
          outros materiais veiculados.
        </p>
        <p class="mb-2">
          5.2. Em alguns casos, os Usuários podem movimentar elevadas quantias
          em ordens de compra e venda executadas por meio da Plataforma, e devem
          estar sempre cientes do risco. Em hipótese alguma a OnTick Invest será
          responsável por danos indiretos ou lucros cessantes dos Usuários.
        </p>
        <p class="mb-2">
          5.3. As estratégias de investimentos apenas executam ordens
          pré-programadas, mas o resultado dessas ordens segue a lógica do
          mercado: ou seja, se trata de investimentos variáveis, voláteis e
          totalmente imprevisíveis. Em hipótese alguma a OnTick Invest terá
          responsabilidade sobre as decisões ou operações que venham a ser
          realizadas como resultado da estratégia de investimentos parametrizada
          pelo Usuário, pela própria OnTick Invest e por seus Parceiros ou por
          terceiros.
        </p>
        <p class="mb-2">
          5.4. É importante lembrar que mesmo que esteja utilizando a Plataforma
          e as estratégias, o Usuários terá sempre acesso direto à sua corretora
          de valores mobiliários, podendo enviar diretamente e a qualquer tempo
          ordens de compra ou venda dos valores mobiliários que estiver
          negociando. Essa possibilidade é muito importante caso haja algum
          imprevisto na atuação das estratégias do Usuário ou da Plataforma,
          pois permite que medidas sejam tomadas pelo Usuário para assegurar
          determinado resultado ou evitar algum prejuízo em suas operações.
        </p>
        <p class="mb-2">
          5.5. A OnTick Invest não garante que as estratégias disponibilizadas
          necessariamente resultem em ganhos financeiros, ainda que
          estatisticamente haja histórico de lucros. Em sentido contrário, a
          OnTick Invest alerta para o elevado risco nas operações com valores
          mobiliários e reforça que qualquer análise pretérita não significa
          possibilidade de ganhos futuros.
        </p>
        <p class="mb-2">
          5.6. A OnTick Invest, em hipótese alguma, promete resultados de ganhos
          certos ou predeterminados.
        </p>
        <p class="mb-2">
          5.7. A OnTick Invest não se responsabiliza por comentários de
          terceiros em particular ou em quaisquer grupos de discussão. Nós
          também não nos responsabilizamos por opiniões e reclamações de
          Usuários sobre determinadas estratégias, de forma que a
          responsabilidade pelas opiniões será exclusiva de quem as emitiu.
        </p>
        <p class="mb-2">
          5.8. A existência de referências ou mesmo links para conteúdo de
          terceiros na Plataforma ou no site da OnTick Invest não induz endosso,
          apoio ou aprovação de qualquer opinião, iniciativa ou organização.
        </p>
        <p class="mb-2">
          5.9. É de responsabilidade do Usuário manter seu sistema protegido
          contra vírus e outros malwares. Dessa forma,
          <b
            >não nos responsabilizamos por danos causados por vírus e
            malwaresem</b
          >
          decorrência de acesso, utilização ou navegação no site na internet ou
          como consequência da transferência de dados, arquivos, imagens, textos
          ou áudio contidos nele. É de responsabilidade do Usuário a
          certificação de estar acessando sua conta em redes seguras.
        </p>
        <p class="mb-2">
          5.10. A OnTick Invest utilizará todos os meios técnicos disponíveis e
          viáveis para que a Plataforma fique sempre acessível de forma estável.
        </p>
        <p class="mb-2">
          5.11. O acesso à internet poderá eventualmente apresentar
          instabilidade, já que toda transmissão de dados através da rede
          mundial de computadores está sujeita a atrasos ou até mesmo
          interrupções, de forma que a OnTick Invest não se responsabiliza por
          quaisquer atrasos no acompanhamento de dados ou no envio de ordem,
          causados por questões técnicas ou serviços disponibilizados por
          terceiros.
        </p>
        <p class="mb-2">
          5.12. A OnTick Invest disponibiliza informações provenientes do
          mercado financeiro em tempo quase real como forma de auxiliar os
          Usuários a parametrizar e acompanhar suas Estratégias, no entanto,
          tais dados estão sujeitos a fatores externos que podem gerar atrasos
          ou incorreções da fonte respectiva, no que não poderá a OnTick Invest
          ser responsabilizada.
        </p>
        <p class="mb-6">
          5.13. A OnTick Invest, sempre que ocorra eventual interrupção nos seus
          serviços, envidará seus melhores esforços para avisar os Usuários e
          restabelecer a normalidade do seu funcionamento, sempre no menor tempo
          possível.
        </p>

        <h3 class="mb-2 text-xl font-bold">6. Rescisão dos Planos</h3>
        <p class="mb-2">
          6.1. O Usuário poderá, a qualquer momento e independente de motivação,
          cancelar a renovação automática do plano contratado de produtos
          diretamente através da Plataforma.
        </p>
        <p class="mb-6">
          6.2. A OnTick Invest poderá advertir, suspender ou cancelar,
          temporária ou definitivamente, a conta de um Usuário a qualquer
          momento, além de tomar as medidas legais cabíveis se: (1) o Usuário
          não cumprir qualquer dispositivo desses Termos de Uso; (2) o Usuário
          praticar atos fraudulentos, dolosos ou com evidente má-fé, a fim de
          obter vantagem indevida; (3) forem identificados atos do Usuário
          realizados com a finalidade de induzir ao erro para obter vantagem
          manifestamente ilícita; (4) não puder ser verificada a identidade do
          Usuário ou qualquer informação fornecida por ele seja inverídica; (5)
          alguma atitude do Usuário tiver o condão de causar danos a terceiros
          ou à própria OnTick Invest; (6) o Usuário divulgar ou postar conteúdo
          em desacordo com a legislação vigente, com os bons costumes, ou
          ofensivo ao direito de qualquer pessoa; (7) o Usuário adotar, no
          âmbito da relação com a OnTick Invest, bem como seus representantes e
          funcionários, condutas desrespeitosas, ofensivas, difamatórias,
          obscenas, ilegais ou realizar ameaças; e (8) praticar SPAM ou qualquer
          tipo de atitudes contrárias às boas práticas da internet e das redes
          sociais.
        </p>

        <h3 class="mb-2 text-xl font-bold">7. Comunicação Entre as Partes</h3>
        <p class="mb-6">
          7.1. Caso o Usuário tenha qualquer dúvida, comentário, sugestão ou
          reclamação sobre serviços disponibilizados pela Plataforma, poderá
          entrar em contato conosco por meio de nossos canais de atendimento
          através do endereço https://ajuda.ontick.com.br.
        </p>

        <h3 class="mb-2 text-xl font-bold">8. Envio de Newsletters</h3>
        <p class="mb-6">
          8.1. A OnTick Invest poderá enviar para o seu e-mail novidades e
          informações. O Usuário poderá cancelar o envio de newsletter no link
          disponível no canto inferior dos e-mails ou através do canal de
          atendimento disponível em https://ajuda.ontick.com.br.
        </p>

        <h3 class="mb-2 text-xl font-bold">9. Considerações Finais</h3>
        <p class="mb-2">
          9.1. Esse Termos de Uso constitui documento jurídico integral e
          perfeito para regular a relação, e poderá ser modificado livremente e
          a qualquer tempo pela OnTick Invest. Dessa forma, será enviado um
          aviso aos Usuários informando sempre que ocorrerem mudanças. Os novos
          termos terão validade a partir da data em que forem veiculados no site
          da OnTick Invest, reservando-se ao Usuário o direito de permanecer
          cadastrado ou de solicitar a descontinuidade dos serviços. Caso o
          Usuário não manifeste sua discordância e/ou solicite a descontinuidade
          dos serviços, a OnTick Invest considerará, legitimamente, a
          concordância tácita aos novos Termos de Uso.
        </p>
        <p class="mb-2">
          9.2. A OnTick Invest poderá, a qualquer momento e a seu exclusivo
          critério, modificar a configuração da Plataforma, acrescentando ou
          eliminando funcionalidades, podendo também eliminar ou acrescentar
          quaisquer produtos do marketplace.
        </p>
        <p class="mb-2">
          9.3. Todo o conteúdo (incluindo, mas não se limitando a marcas,
          modelos, textos, programas de computador, sons, fotografias e outros
          materiais disponíveis no site da OnTick Invest), a aparência, a
          organização e a estrutura da OnTick Invest são protegidas pela
          legislação de propriedade intelectual e não infringem qualquer lei ou
          norma a que estejam subordinadas, contratos, documentos, acordos dos
          quais faz parte, bem como não infringem direitos de terceiros. A
          violação de tais direitos ensejará a respectiva indenização aos
          prejudicados, sem prejuízo de perdas e danos e honorários
          advocatícios.
        </p>
        <p class="mb-2">
          9.4. É vedado ao Usuário modificar, copiar, distribuir, transmitir,
          exibir, realizar, reproduzir, publicar, disponibilizar, licenciar ou
          criar obras derivadas a partir das informações coletadas na
          Plataforma, bem como transferir ou vender tais informações, software,
          produtos ou serviços, sob pena de violação do presente termo e
          infração legal.
        </p>
        <p class="mb-2">
          9.5. Os serviços oferecidos pela OnTick Invest estão disponíveis
          apenas para as pessoas que tenham capacidade legal para contratá-los.
        </p>
        <p class="mb-2">
          9.5.1. O Usuário declara e garante que possui capacidade para tanto,
          ou seja, é maior de idade ou está devidamente representado por seus
          pais ou representantes legais.
        </p>
        <p class="mb-2">
          9.5.2. Caso o Usuário seja pessoa jurídica, ele declara e garante que
          está representado por pessoa física com poderes suficientes para
          contratar a OnTick Invest, devidamente constantes em instrumento
          próprio, registrado no órgão competente.
        </p>
        <p class="mb-2">
          9.6. Se houver algum conflito de informações constantes neste contrato
          com outros documentos, prevalecerão sempre os termos deste contrato,
          que é o documento formal eleito para reger nossa relação
        </p>
        <p class="mb-2">
          9.7. Por fim, caso seja necessário dirimir qualquer dúvida ou
          controvérsia decorrente deste contrato, o foro eleito é o da Comarca
          de Vitória/ES, com renúncia de todos os outros, por mais privilegiados
          que sejam. Isto significa que, caso seja necessário discutirmos algo
          na Justiça, as ações devem ser propostas em Vitória/ES.
        </p>
        <p class="mb-6">
          9.8. Agora que você já leu todos os nossos Termos de Uso, poderá
          indicar se está de acordo com todos eles realizando o seu cadastro e
          se tornando um Usuário OnTick Invest!
        </p>

        <b>OnTick Invest Serviços Financeiros LTDA.</b>
      </div>
    </div>
  </ontick-modal>
</template>

<script>
export default {
  props: {
    active: { type: Boolean, default: null },
  },
};
</script>

<style></style>
